module.exports = {
  blank: 'Select a date...',
  headerFormat: 'ddd, MMM Do',
  todayLabel: {
    long: 'Today'
  },
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekStartsOn: 0
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite-calendar/es/utils/defaultLocale.js
// module id = 1195
// module chunks = 0